/**
 * Retrieve postcode and city input of a type
 * 
 * @returns {Object} object of all inputs { postcodeInput, cityInput }
 */
export function getInputsByType(type) {
    const postcodeInput = document.getElementById(type + "_postcode") ?? null;
    const cityInput = document.getElementById(type + "_city") ?? null;

    let inputs = {
        postcodeInput: postcodeInput,
        cityInput: cityInput
    };

    return inputs;
}

/**
 * Retrieve postcode and city input fields
 * 
 * @returns {Object} object of all fields { postcodeField, cityField }
 */
export function getInputFieldsByType(type) {
    const postcodeField = document.getElementById(type + "_postcode_field") ?? null;
    const cityField = document.getElementById(type + "_city_field") ?? null;

    let fields = {
        postcodeField: postcodeField,
        cityField: cityField
    };

    return fields;
}

/**
 * Set validated classes for input field
 * 
 * @param {Object} inputField 
 */
export function setValidated(inputField) {
    inputField.classList.remove('woocommerce-invalid');
    inputField.classList.remove('woocommerce-invalid-required-field');
    inputField.classList.add('woocommerce-validated');
}

/**
 * Set invalid classes for input field
 * 
 * @param {Object} inputField 
 */
export function setInvalid(inputField) {
    inputField.classList.remove('woocommerce-validated');
    inputField.classList.add('woocommerce-invalid');
    inputField.classList.add('woocommerce-invalid-required-field');
}

/**
 * Set validation classes for input and input field
 * 
 * @param {Object} input 
 * @param {Object} inputField 
 * 
 * @returns {void}
 */
export function setValidationClasses(input, inputField) {
    if (input.value === '') {
        return;
    }

    const inputType = localStorage.getItem('sef-shippingType');

    let validation = localStorage.getItem('sef-' + inputType + '-validation') ?? '';

    if (validation === '') {
        setValidated(inputField);
    }

    if (validation === 'warning') {
        setValidated(inputField);
    }

    if (validation === 'error') {
        setInvalid(inputField);
    }
}

/**
 * Set value for the input
 * 
 * @param {Object} input 
 * @param {Object} field 
 * @param {string} value 
 */
export function setInputValue(input, field, value) {
    if (input.value === '') {
        input.setAttribute('value', value);
        input.value = value;

        setValidated(field);
    }
}

/**
 * Set loading spinner on input field
 * 
 * @param {Object} inputField 
 */
export function addLoadingSpinnerOnInput(inputField) {
    inputField.classList.add('blockUI');
    inputField.classList.add('blockOverlay');
}

/**
 * Remove loading spinner on input field
 * 
 * @param {Object} inputField 
 */
export function removeLoadingSpinnerOnInput(inputField) {
    inputField.classList.remove('blockUI');
    inputField.classList.remove('blockOverlay');
}

/**
 * Insert new element (newNode) after another element (referenceNode)
 * 
 * @param {Object} referenceNode 
 * @param {Object} newNode 
 */
export function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

/**
 * Set error message for the input
 * 
 * @param {string} errorText 
 * @param {Object} inputField 
 * @param {Object} input 
 */
export function setInputFieldErrorMsg(errorText, inputField, input) {
    let errorMsg = document.getElementById('sef-checkout-' + inputField.id + '-error-message');

    if (errorText != '') {
        if (errorMsg === null) {
            errorMsg = document.createElement('p');
            errorMsg.setAttribute('id', 'sef-checkout-' + inputField.id + '-error-message');

            insertAfter(input.parentElement, errorMsg);
        }
        errorMsg.innerText = errorText;

        return errorMsg;
    } else if (errorText === '' && errorMsg != null) {
        errorMsg.remove();
    }
    return false;
}

/**
 * Set error message as error
 * 
 * @param {Object} errorMsg 
 */
export function setMessageError(errorMsg) {
    if (errorMsg) {
        errorMsg.setAttribute('class', 'sef-checkout-error-message');
    }
}

/**
 * Set error message as warning
 * @param {Object} errorMsg 
 */
export function setMessageWarning(errorMsg) {
    if (errorMsg) {
        errorMsg.setAttribute('class', 'sef-checkout-warning-message');
    }
}
